<template>
  <div class="qiwei">
    <div class="banner">
      <img class="banner_img" src="../../assets/img/qiwei/banner.png" alt="">
      <div class="banner_text">
        <h4>
          连接创造价值 微信直聊招聘
        </h4>
        <div class="button_group">
              <div class="button"  @click="goRegister" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>注册企业微信</span>
              </div>
              <div class="button"  @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>安装到企业微信</span>
              </div>
              <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>企业微信登录</span>
              </div>
            </div>
        <div class="try" @click="goTry" style="cursor:pointer;">立即试用</div>
      </div>
    </div>
    <div class="content2">
      <ul>
        <li>
          <span class="left">
            <img src="../../assets/img/qiwei/content_1.png">
          </span>
          <div class="gap"></div>
          <span class="right">
            <h6>
              企微客服、微信好友连接HR 与候选人
            </h6>
            <p>全日程安排调取企业微信日历并支持一键同步，减少沟通成本，不错过任何一个好的候选人</p>
          </span>
        </li>
        <li>
          <span class="left">
            <h6>
              企微会议日程联通
            </h6>
            <p>全日程安排调取企业微信日历并支持一键同步，减少沟通成本，不错过任何一个候选人</p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img src="../../assets/img/qiwei/content_2.png">
          </span>
        </li>
        <li>
          <span class="left">
            <img src="../../assets/img/qiwei/content_3.png">
          </span>
          <div class="gap"></div>
          <span class="right">
            <h6>
              全流程高效协同
            </h6>
            <p>一站式招聘管理，线上对候选人高效添加、面试、入职，海量数据直观展现提升HR效率</p>
          </span>
        </li>
        <li>
          <span class="left">
            <h6>
              联通所有招聘渠道
            </h6>
            <p>沉淀所有招聘渠道人才打造最强人才库</p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img src="../../assets/img/qiwei/content_4.png">
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {
    goRegister(){
      let url = 'https://work.weixin.qq.com/wework_admin/register_wx'
      window.open(url,'_blank')
    },
    goUse(){
      let url = 'https://open.work.weixin.qq.com/3rdservice/wework/register?permanent_reg_code=ww8db26cd2bd27f524882e5e8da472e492e1efa7e6cd758c07&notreplace=true#/v1/h5https://open.work.weixin.qq.com/3rdservice/wework/register?permanent_reg_code=ww8db26cd2bd27f524882e5e8da472e492e1efa7e6cd758c07&notreplace=true#/v1/h5'
      window.open(url,'_blank')
    },
    goLogin(){
      let url = 'https://redcs.tencent.com/'
      window.open(url,'_blank')
    },
    goTry(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNTAzMTQ0MDI1NF8xMDI5NzczXzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    }
  }
};
</script>
<style lang="scss">
.qiwei {
  .banner {
    position: relative;
    .banner_img {
      height: 100%;
    }
    .banner_text {
      position: absolute;
      top: 174px;
      left: 360px;
      h4 {
        font-size: 60px;
        font-weight: 600;
        color: #26292c;
      }
      .button_group {
        display: flex;
        gap: 16px;
        margin-top: 40px;
        .button {
          height: 40px;
          line-height: 38px;
          font-size: 14px;
          font-weight: 400;
          color: #007bff;
          padding: 0 18px;
          border: 1px solid #007bff;
          border-radius: 4px;
          >img {
            width: 18px;
            height: 17px;
            vertical-align: middle;
          }
          >span {
            vertical-align: middle;
          }
        }
      }
    }
    .try {
      width: 300px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #007bff;
      border: 1px solid #007bff;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/qiwei.vue